var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.53748 0 0.5 4.03748 0.5 9C0.5 13.9625 4.53748 18 9.5 18C14.4625 18 18.5 13.9625 18.5 9C18.5 4.03748 14.4625 0 9.5 0ZM9.5 16.875C5.15764 16.875 1.625 13.3424 1.625 9C1.625 4.65764 5.15764 1.125 9.5 1.125C13.8424 1.125 17.375 4.65764 17.375 9C17.375 13.3424 13.8424 16.875 9.5 16.875ZM13.2727 8.60231C13.325 8.65452 13.3664 8.71651 13.3947 8.78475C13.423 8.85298 13.4376 8.92613 13.4376 9C13.4376 9.07387 13.423 9.14702 13.3947 9.21525C13.3664 9.28349 13.325 9.34549 13.2727 9.39769L10.4602 12.2102C10.3504 12.32 10.2064 12.375 10.0625 12.375C9.91864 12.375 9.77464 12.32 9.66481 12.2102C9.61255 12.158 9.57108 12.096 9.5428 12.0278C9.51451 11.9595 9.49995 11.8864 9.49995 11.8125C9.49995 11.7386 9.51451 11.6655 9.5428 11.5972C9.57108 11.529 9.61255 11.467 9.66481 11.4148L11.5171 9.5625H6.125C5.81436 9.5625 5.5625 9.31092 5.5625 9C5.5625 8.68908 5.81436 8.4375 6.125 8.4375H11.5171L9.66481 6.58519C9.44501 6.36539 9.44501 6.00947 9.66481 5.78981C9.88461 5.57016 10.2405 5.57002 10.4602 5.78981L13.2727 8.60231Z",
    fill: "#3176BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNext);
export default __webpack_public_path__ + "static/media/Table-Next.0a627acf16429de35b0b4ec3324f709d.svg";
export { ForwardRef as ReactComponent };